import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-terms',
    imports: [CommonModule],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.less'
})
export class TermsComponent {
  
  @Input() showTerms: boolean = false;
  @Output() closeTermsEvent: EventEmitter<void> = new EventEmitter<void>();

  closeTerms() {
    this.closeTermsEvent.emit();
  }

}
